export default "__VITE_ASSET__BoiQhyOT__"